import { useLocation, useNavigate } from 'react-router-dom';
import { getAppChainConfig, isTestMode } from '../utils/network';

/**
 * Fixed banner when the user is on ?test=true with a build that allows test mode.
 * Same UI code paths as production; chain + API follow Base Sepolia + test header.
 */
export default function TestModeBanner() {
  const location = useLocation();
  const navigate = useNavigate();

  if (!isTestMode()) return null;

  const cfg = getAppChainConfig();
  const chainLabel = cfg.chainName || 'testnet';

  const exitTestMode = () => {
    const p = new URLSearchParams(location.search);
    p.delete('test');
    const q = p.toString();
    navigate({ pathname: location.pathname, search: q ? `?${q}` : '' }, { replace: true });
  };

  return (
    <div className="app-test-mode-banner" role="status" aria-live="polite">
      <span className="app-test-mode-banner-text">
        Test environment — {chainLabel} (chain {cfg.chainId}). No real money; use test ETH only.
      </span>
      <button type="button" className="app-test-mode-banner-exit" onClick={exitTestMode}>
        Exit test mode
      </button>
    </div>
  );
}
